import { DatePicker } from "antd";

const TimeZoneDatePicker = ({ value, onChange, timezoneToday, ...rest }) => {
  return (
    <DatePicker
      {...rest}
      value={value}
      onChange={onChange}
      cellRender={(date, info) => {
        const isTimezoneToday = date.isSame(timezoneToday, "day");
        const defaultNode = info.originNode;

        return (
          <div style={{ position: "relative" }}>
            {defaultNode}
            {isTimezoneToday && (
              <div
                style={{
                  position: "absolute",
                  top: 2,
                  left: 2,
                  right: 2,
                  bottom: 2,
                  color: "#fff",
                  borderRadius: 4,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 12,
                  pointerEvents: "none",
                }}
              >
                {date.date()}
              </div>
            )}
          </div>
        );
      }}
    />
  );
};

export default TimeZoneDatePicker;
